/* global KTUtil, KTLayoutContent */

export default class ConversationCard {
  static selectorString() {
    return '.ConversationCard';
  }

  render(node, props) {
    // NOTE: initialize perfect scrollbar (see: https://github.com/utatti/perfect-scrollbar)
    this.scrollNode = node.querySelector('.scroll');

    KTUtil.scrollInit(this.scrollNode, {
      mobileNativeScroll: true,
      desktopNativeScroll: false,
      resetHeightOnDestroy: true,
      handleWindowResize: true,
      // TODO: remember position: does not seem to work: check and fix
      rememberPosition: true,
      height: () => {
        return this.getScrollHeight();
      },
    });

    setTimeout(this.loaded.bind(this), 170);
    setTimeout(this.loaded.bind(this), 340);
    window.addEventListener('load', this.loaded.bind(this));
  }

  getScrollHeight() {
    if (KTUtil.isBreakpointUp('lg')) {
      const layoutContentHeight = KTLayoutContent.getHeight();
      const spaceAround = this.node.offsetHeight - this.scrollNode.offsetHeight;
      return layoutContentHeight - spaceAround;
    }

    return null;
  }

  loaded() {
    this.setScrollHeight();
    setTimeout(this.setScrollHeight.bind(this), 170);
    setTimeout(this.setScrollHeight.bind(this), 340);
  }

  setScrollHeight() {
    this.scrollNode.style.height = `${this.getScrollHeight()}px`;
  }
}
